import React from 'react';


function Nodatafound() {
  return <div className="no-data-container">   <p>No data found.</p></div>;
}

export default Nodatafound;